import AddRestaurantForm from './AddRestaurantForm'
export default AddRestaurantForm
